import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withArraySearchFilter,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMappingConfiguration,
    withDefaultSearchParamsMetadata,
    withFragmentSearchFilter,
    withMetadata,
    withSearchFilter,
} from '@pf/shared-utility';
import {
    AuditCreate,
    AuditDto,
    AuditRead,
    AuditSearchParams,
} from '../../entities/audit.dto';
import {
    CustomFieldMetadataMap,
    ResourceAuthSymbol,
} from '@pf/shared/util-platform';
import { withWarehouseSearchFilter } from '../wms-mapping.util';

const symbols = entitySymbols(PFWmsEntities.Audit);

withDefaultEntityMetadata<AuditDto>(symbols.dto, {
    assignedTo: String,
    auditDate: String,
    priority: String,
    resourceAuth: ResourceAuthSymbol,
    startDate: String,
    dueDate: String,
    item: Object,
    inventoryBundle: Object,
    warehouse: Object,
    auditType: Object,
    customFields: [CustomFieldMetadataMap.symbols.dto],
    auditScheduleId: String,
    status: String,
    auditCounts: [Object],
});

withDefaultEntityMetadata<AuditRead>(symbols.entity, {
    assignedTo: String,
    auditDate: String,
    priority: String,
    resourceAuth: ResourceAuthSymbol,
    startDate: String,
    dueDate: String,
    item: Object,
    inventoryBundle: Object,
    warehouse: Object,
    auditType: Object,
    customFields: [CustomFieldMetadataMap.symbols.dto],
    auditScheduleId: String,
    status: String,
    auditCounts: [Object],
});

withMetadata<AuditCreate>(symbols.createBody, {
    assignedTo: String,
    auditDate: String,
    priority: String,
    startDate: String,
    dueDate: String,
    warehouseId: String,
    itemId: String,
    inventoryBundleId: String,
    auditTypeId: String,
    resourceAuth: ResourceAuthSymbol,
    status: String,
    auditCounts: [Object],
});

withDefaultSearchParamsMetadata<AuditSearchParams>(symbols.searchParams, {
    itemId: String,
    auditStartDate: String,
    auditEndDate: String,
    containerId: String,
    zoneId: String,
    slotId: String,
    warehouseId: String,
    assignedTo: String,
    auditScheduleId: String,
    auditTypeId: String,
    search: String,
    createdStartDate: String,
    createdEndDate: String,
    modifiedStartDate: String,
    modifiedEndDate: String,
    priority: String,
    status: Array<string>,
});

export const AuditMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<AuditRead, AuditDto>(mapper, symbols.entity, symbols.dto);
        createMap<AuditDto, AuditRead>(mapper, symbols.dto, symbols.entity);
        createMap<AuditDto, AuditCreate>(
            mapper,
            symbols.dto,
            symbols.createBody
        );
        createMap<IQueryParams<AuditDto>, AuditSearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            withSearchFilter('priority'),
            withSearchFilter('assignedTo'),
            withFragmentSearchFilter('auditType'),
            withArraySearchFilter('status'),
            withWarehouseSearchFilter(),
            ...withDefaultSearchParamsMappingConfiguration()
        );
    },
};
